import React from "react";
import { Badge } from "@/components/ui/badge";
import { Users, Eye, Edit, Shield } from "lucide-react";
import { ProjectWithAccess } from "@/services/projectService";

interface GuestProjectBadgeProps {
  project: ProjectWithAccess;
  className?: string;
}

export function GuestProjectBadge({
  project,
  className = "",
}: GuestProjectBadgeProps) {
  if (project.access_type === "owner") {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Badge
          variant="outline"
          className="text-blue-600 border-blue-200 bg-blue-50 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800"
        >
          <Shield className="h-3 w-3 mr-1" />
          Owner
        </Badge>
        {(project.guest_count ?? 0) > 0 && (
          <Badge
            variant="outline"
            className="text-emerald-600 border-emerald-200 bg-emerald-50 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800"
          >
            <Users className="h-3 w-3 mr-1" />
            {project.guest_count}{" "}
            {project.guest_count === 1 ? "guest" : "guests"}
          </Badge>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Badge
        variant="outline"
        className="text-emerald-600 border-emerald-200 bg-emerald-50 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800"
      >
        <Users className="h-3 w-3 mr-1" />
        Guest Access
      </Badge>

      {project.guest_permissions && (
        <div className="flex items-center gap-1">
          {project.guest_permissions.view && (
            <div className="flex items-center gap-1 text-xs text-green-600 dark:text-green-400 bg-green-50 dark:bg-green-900/20 px-2 py-0.5 rounded">
              <Eye className="h-3 w-3" />
              View
            </div>
          )}
          {project.guest_permissions.edit && (
            <div className="flex items-center gap-1 text-xs text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/20 px-2 py-0.5 rounded">
              <Edit className="h-3 w-3" />
              Edit
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default GuestProjectBadge;
